<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Harvesting', apiMethod: 'Harvestings', form: () => import('../forms/HarvestingForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Cleaning', apiMethod: 'Cleanings', parentForeignKey: 'harvestingId', form: () => import('../forms/CleaningForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Container Fill', apiMethod: 'ContainerFills', parentForeignKey: 'harvestingId', form: () => import('../forms/ContainerFillForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Harvesting Floral Variety', apiMethod: 'HarvestingFloralVarieties', parentForeignKey: 'harvestingId', form: () => import('../forms/HarvestingFloralVarietyForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Cleanings', value: 'harvestingId', isCard: true, table: () => import('../tables/CleaningsTable') },
                    { text: 'Container Fills', value: 'harvestingId', isCard: true, table: () => import('../tables/ContainerFillsTable') },
                    { text: 'Floral Varieties', value: 'harvestingId', isCard: true, table: () => import('../tables/HarvestingFloralVarietiesTable') },
                    { text: 'Samples', value: 'harvestingId', table: () => import('../tables/SamplesTable') },
                ],
                mainForm: () => import('../forms/HarvestingForm'),
                claimName: 'Harvestings',
                apiMethod: 'Harvestings',
            }
        }
    };
</script>
